import { render, staticRenderFns } from "./assignments-table.vue?vue&type=template&id=4a7a5f69"
import script from "./assignments-table.vue?vue&type=script&lang=js"
export * from "./assignments-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports